module.exports = __webpack_public_path__ + "img/humidity.58c65d3b.svg";